import React from 'react';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SlackChannelActionsEditChannel = (props: $FIXME) => {
  return (
    <>
      <div className="current-channel-container">
        <Tooltip title="Cancel Edit Channel" placement="top" arrow>
          <div
            className={`edit-button ${props.isLoading ? 'disabled' : ''}`}
            onClick={() => props.onCancelEdit?.(props.channel)}
          >
            <FontAwesomeIcon icon="ban" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
        <Tooltip title="Remove Channel" placement="top" arrow>
          <div
            className={`remove-button ${props.isLoading ? 'disabled' : ''}`}
            onClick={() => props.onRemove?.(props.channel)}
          >
            <FontAwesomeIcon icon="trash" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
      </div>
      <style jsx>{`
        .current-channel-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActionsEditChannel;
